/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentInfo as AgentApiContractAgentInfo } from '../../models/AgentApi/Contract/agent-info';

export interface ApiAgentListAgentGet$Plain$Params {

/**
 * Interface language
 */
  lang?: string;
}

export function apiAgentListAgentGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentListAgentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentInfo>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListAgentGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractAgentInfo>>;
    })
  );
}

apiAgentListAgentGet$Plain.PATH = '/api/Agent/ListAgent';
